(function(){
  if (window.CustomATCToast) return;

  var state = {
    open: false,
    variantId: null,
    productTitle: '',
    variantTitle: '',
    image: null,
    quantity: 1
  };

  var root = null;
  var listenersBound = false;

  function ensureRoot() {
    if (!root) {
      root = document.getElementById('custom-atc-toast-root');
    }
    return root;
  }

  function bindListenersOnce() {
    if (listenersBound) return;
    var overlay = ensureRoot();
    if (!overlay) return;

    // Close on outside click
    overlay.addEventListener('click', onOverlayClick);

    // Close button
    var closeBtn = overlay.querySelector('.custom-atc-toast__close');
    if (closeBtn) closeBtn.addEventListener('click', hide);

    // Continue shopping
    var continueBtn = overlay.querySelector('.js-continue');
    if (continueBtn) continueBtn.addEventListener('click', hide);

    // View cart
    var viewCart = overlay.querySelector('.js-view-cart');
    if (viewCart) viewCart.addEventListener('click', function(){
      hide();
      if (window.qf_side_cart && typeof window.qf_side_cart.openSideCart === 'function') {
        window.qf_side_cart.openSideCart();
      } else {
        window.location.href = '/cart';
      }
    });

    // Quantity buttons
    var minus = overlay.querySelector('.js-minus');
    var plus = overlay.querySelector('.js-plus');
    if (minus) minus.addEventListener('click', function(){ updateQty(Math.max(0, state.quantity - 1)); });
    if (plus) plus.addEventListener('click', function(){ updateQty(state.quantity + 1); });

    listenersBound = true;
  }

  function render() {
    var overlay = ensureRoot();
    if (!overlay) return;

    if (!state.open) {
      overlay.classList.remove('is-active');
      overlay.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeyDown);
      return;
    }

    // Open and populate
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');

    var imgEl = overlay.querySelector('.custom-atc-toast__image img');
    if (imgEl) {
      if (state.image) {
        imgEl.src = state.image;
        imgEl.alt = state.productTitle || '';
        imgEl.style.visibility = '';
      } else {
        imgEl.removeAttribute('src');
        imgEl.alt = '';
        imgEl.style.visibility = 'hidden';
      }
    }

    var titleEl = overlay.querySelector('.custom-atc-toast__product-title');
    if (titleEl) titleEl.textContent = state.productTitle || '';

    var variantEl = overlay.querySelector('.custom-atc-toast__variant-title');
    if (variantEl) {
      if (state.variantTitle) {
        variantEl.textContent = state.variantTitle;
        variantEl.style.display = '';
      } else {
        variantEl.textContent = '';
        variantEl.style.display = 'none';
      }
    }

    var qtyEl = overlay.querySelector('.js-qty');
    if (qtyEl) qtyEl.textContent = String(state.quantity || 1);

    // Bind keydown only while open
    document.addEventListener('keydown', onKeyDown);

    // Ensure event listeners are bound once
    bindListenersOnce();
  }

  function onOverlayClick(e) {
    // close if click outside toast
    var overlay = ensureRoot();
    if (!overlay) return;
    var toast = overlay.querySelector('.custom-atc-toast');
    if (!toast) return;
    if (!toast.contains(e.target)) hide();
  }

  function onKeyDown(e) {
    if (e.key === 'Escape') hide();
  }

  function hide() {
    state.open = false;
    render();
  }

  function setButtonsDisabled(disabled) {
    var overlay = ensureRoot();
    if (!overlay) return;
    var btns = overlay.querySelectorAll('.custom-atc-toast__qty button');
    btns.forEach(function(b){ b.disabled = disabled; });
  }

  function updateQty(newQty) {
    if (state.variantId == null) return;
    setButtonsDisabled(true);

    if (newQty <= 0) {
      if (window.qf_cart && typeof window.qf_cart.updateCart === 'function') {
        window.qf_cart.updateCart(state.variantId, 0);
      }
      return;
    }

    // Prefer updateCart to set absolute quantity
    if (window.qf_cart && typeof window.qf_cart.updateCart === 'function') {
      window.qf_cart.updateCart(state.variantId, newQty);
    } else if (window.qf_cart && typeof window.qf_cart.addToCart === 'function') {
      var delta = Math.max(0, newQty - state.quantity);
      if (delta > 0) window.qf_cart.addToCart(state.variantId, delta);
    }
  }

  function syncFromCart() {
    if (!window.qf_cart || typeof window.qf_cart.getCart !== 'function') return;
    window.qf_cart.getCart(function(response){
      try {
        var items = (response && response.data && response.data.items) ? response.data.items : [];
        var li = null;
        for (var i = 0; i < items.length; i++) {
          // Shopify returns variant id as item.id
          if (String(items[i].id) === String(state.variantId)) { li = items[i]; break; }
        }
        if (!li) { hide(); return; }
        state.quantity = li.quantity;
        // try to update image/title if missing
        if (!state.image && li.image) state.image = li.image;
        if (!state.variantTitle && li.variant_title) state.variantTitle = li.variant_title;
        render();
      } catch (err) {
        // swallow
      } finally {
        setButtonsDisabled(false);
      }
    });
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function inferImageFromItem(item) {
    if (!item) return null;
    if (item.image) return item.image;
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    if (item.featured_image) return item.featured_image;
    return null;
  }

  function showFromDetail(detail) {
    try {
      // If cart drawer is open, do not show the custom toast
      var cartDrawer = document.getElementById('cart-drawer-container');
      if (cartDrawer && cartDrawer.classList.contains('open')) {
        return;
      }

      var item = null;
      if (detail && detail.response && detail.response.data && detail.response.data.items && detail.response.data.items[0]) {
        item = detail.response.data.items[0];
      }
      if (!item) return;

      // Check multibuy status before showing the toast
      var productHandle = item.handle || item.product_handle;
      
      if (productHandle) {
        // Fetch product data to check tags before showing toast
        fetch(`/products/${productHandle}.js`)
          .then(response => response.json())
          .then(product => {
            var hasMultibuyTag = product.tags && product.tags.some(tag => 
              tag.toLowerCase().includes('multibuy')
            );
            
            // Set the multibuy header state before showing the toast
            setMultibuyHeaderState(hasMultibuyTag);
            
            // Now show the toast with the correct header state
            showToastWithData(item);
          })
          .catch(() => {
            // If we can't fetch product data, hide the header and show toast
            setMultibuyHeaderState(false);
            showToastWithData(item);
          });
      } else {
        // If no product handle available, hide the header and show toast
        setMultibuyHeaderState(false);
        showToastWithData(item);
      }
    } catch (e) {
      // no-op
    }
  }

  function setMultibuyHeaderState(show) {
    var multibuyHeader = document.querySelector('.js-multi-buy-header');
    if (!multibuyHeader) return;
    
    if (show) {
      multibuyHeader.classList.remove('is-hidden');
    } else {
      multibuyHeader.classList.add('is-hidden');
    }
  }

  function showToastWithData(item) {
    state.open = true;
    state.variantId = item.id || item.variant_id || null;
    state.productTitle = item.product_title || item.title || '';
    state.variantTitle = item.variant_title || '';
    state.image = inferImageFromItem(item);
    state.quantity = item.quantity || 1;

    render();

    // Re-render side cart to reflect the change
    if (window.qf_side_cart && typeof window.qf_side_cart.reRenderSideCart === 'function') {
      window.qf_side_cart.reRenderSideCart();
    }

    // Subscribe to cart updates while open
    window.addEventListener('cart_changed', onCartChanged);
    window.addEventListener('item_removed', onItemRemoved);
  }

  function onCartChanged() {
    if (!state.open) return;
    syncFromCart();
    if (window.qf_side_cart && typeof window.qf_side_cart.reRenderSideCart === 'function') {
      window.qf_side_cart.reRenderSideCart();
    }
  }

  function onItemRemoved(e) {
    if (!state.open) return;
    // If the removed item matches, close
    try {
      var vid = e && e.detail && (e.detail.variant_id || e.detail.id);
      if (vid && String(vid) === String(state.variantId)) {
        hide();
      }
    } catch(_) {}
  }

  window.CustomATCToast = {
    show: function(detail){ showFromDetail(detail); },
    hide: hide
  };

  // Hook into the global item_added event to trigger the custom toast
//   window.addEventListener('item_added', function (e) {
//     if (window.QF && window.QF.settings && window.QF.settings.ajax_toast) {
//       if (window.CustomATCToast && typeof window.CustomATCToast.show === 'function') {
//         window.CustomATCToast.show(e.detail);
//       }
//     }
//   });
})();